module.exports = __webpack_public_path__ + "img/img-6.a11a58fe.jpg";